module.exports = __webpack_public_path__ + "img/joker.125db6fa.png";